module.exports = __webpack_public_path__ + "static/media/04.b3a58584.mp3";